export const SPOKEN_LANGUAGES = [
  {
    code: "en",
    name: "English",
  },
  {
    code: "it",
    name: "Italian",
  },
  {
    code: "zh",
    name: "Chinese (Mandarin)",
  },
  {
    code: "hi",
    name: "Hindi",
  },
  {
    code: "es",
    name: "Spanish",
  },
  {
    code: "ar",
    name: "Arabic",
  },
  {
    code: "fr",
    name: "French",
  },
  {
    code: "bn",
    name: "Bengali",
  },
  {
    code: "pt",
    name: "Portuguese",
  },
  {
    code: "ru",
    name: "Russian",
  },
  {
    code: "ur",
    name: "Urdu",
  },
  {
    code: "id",
    name: "Indonesian",
  },
  {
    code: "de",
    name: "German",
  },
  {
    code: "ja",
    name: "Japanese",
  },
  {
    code: "sw",
    name: "Swahili",
  },
  {
    code: "mr",
    name: "Marathi",
  },
  {
    code: "te",
    name: "Telugu",
  },
  {
    code: "tr",
    name: "Turkish",
  },
  {
    code: "ta",
    name: "Tamil",
  },
  {
    code: "ko",
    name: "Korean",
  },
  {
    code: "vi",
    name: "Vietnamese",
  },
  // Additional European languages
  {
    code: "pl",
    name: "Polish",
  },
  {
    code: "uk",
    name: "Ukrainian",
  },
  {
    code: "ro",
    name: "Romanian",
  },
  {
    code: "nl",
    name: "Dutch",
  },
  {
    code: "el",
    name: "Greek",
  },
  {
    code: "hu",
    name: "Hungarian",
  },
  {
    code: "cs",
    name: "Czech",
  },
  {
    code: "sv",
    name: "Swedish",
  },
  {
    code: "bg",
    name: "Bulgarian",
  },
  {
    code: "da",
    name: "Danish",
  },
  {
    code: "fi",
    name: "Finnish",
  },
  {
    code: "sk",
    name: "Slovak",
  },
  {
    code: "no",
    name: "Norwegian",
  },
  {
    code: "hr",
    name: "Croatian",
  },
  {
    code: "lt",
    name: "Lithuanian",
  },
  {
    code: "sl",
    name: "Slovenian",
  },
  {
    code: "et",
    name: "Estonian",
  },
  {
    code: "lv",
    name: "Latvian",
  },
  {
    code: "is",
    name: "Icelandic",
  },
  {
    code: "ga",
    name: "Irish",
  },
  {
    code: "mt",
    name: "Maltese",
  },
  {
    code: "lb",
    name: "Luxembourgish",
  },
];

export const getLanguageName = (code: string) => {
  return SPOKEN_LANGUAGES.find((l) => l.code === code)?.name ?? code;
};

export const PROFICIENCY_LEVELS = [
  "Madrelingua",
  "Professionale",
  "Intermedio",
  "Base",
];

export type ProficiencyLevel = (typeof PROFICIENCY_LEVELS)[number];

export const SUPPORTED_LANGUAGES = [`en`, `it`] as const;
export const DEFAULT_LANGUAGE = `en` as const;
export const FALLBACK_LANGUAGE = `en` as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const ISO_LANGUAGE_CODES = {
  en: `en-GB` as const,
  it: `it-IT` as const,
} satisfies Record<SupportedLanguage, string>;

export const SUPPORTED_LOCALES = Object.values(ISO_LANGUAGE_CODES);

export type ISO_LANGUAGE_CODE =
  (typeof ISO_LANGUAGE_CODES)[keyof typeof ISO_LANGUAGE_CODES];
